const state = {
    logo: '',
  };
  
  const mutations = {
    SET_LOGO: (state, logo) => {
      state.logo = logo
    },
  };
  
  const actions = {
    
  };
  
  export default {
    state,
    mutations,
    actions,
  };
  